import {
  FETCHING_PEOPLE,
  RECEIVE_PEOPLE,
  ERROR_PEOPLE,
  PUBLISH_PEOPLE_COUNT,
  RECEIVE_ORGANIZATIONS,
  RECEIVE_TOTAL
} from '../actions/actionTypes';

const peopleInit = {
  isFetching: false,
  sponsorUsers: null,
  errorPeople: null,
  peopleCount: null,
  organizations: null,
  totalOrganizations: null
};

const peopleReducer = (state = peopleInit, action) => {
  switch (action.type) {
    case FETCHING_PEOPLE:
      return Object.assign({}, state, { isFetching: true, peopleCount: null });
    case RECEIVE_PEOPLE:
      return Object.assign({}, state, { isFetching: false, errorPeople: null }, action.payload);
    case ERROR_PEOPLE:
      return Object.assign({}, state, {
        isFetching: false,
        sponsorUsers: null,
        errorPeople: action.payload,
        peopleCount: null
      });
    case PUBLISH_PEOPLE_COUNT:
      return Object.assign({}, state, { peopleCount: action.payload });
    case RECEIVE_ORGANIZATIONS:
      return Object.assign({}, state, {
        isFetching: false,
        organizations: action.payload.data,
        totalOrganizations: action.payload.total,
        errorPeople: null
      });
    default:
      return state;
  }
};

export default peopleReducer;
